import React from 'react';
import {TextProps} from '@chakra-ui/react';
import {UiText} from '~/components/elements';

interface Props extends TextProps {
  text: string;
  boldTextStyles?: React.CSSProperties;
}

/**
 * Renders a text component with bold parts, which are wrapped in [bold][/bold] tags.
 */
const BoldText = ({text, boldTextStyles, ...rest}: Props) => {
  const splitText = text.split('[bold]');
  const renderedText = splitText.map((part, index) => {
    if (index === 0) {
      return part;
    } else {
      const closeBracketIndex = part.indexOf('[/bold]');
      if (closeBracketIndex !== -1) {
        const boldPart = part.substring(0, closeBracketIndex);
        const regularPart = part.substring(closeBracketIndex + 7); // 7 is the length of '[/bold]'
        return (
          <span key={index}>
            <b style={boldTextStyles}>{boldPart}</b>
            {regularPart}
          </span>
        );
      }
    }
    return null;
  });

  return <UiText {...rest}>{renderedText}</UiText>;
};

export default BoldText;
